import * as types from './types';

export default {
  /* eslint-disable no-param-reassign */
  [types.LOAD_SUCCESS](state, payload) {
    state.documentsList = payload.documents;
    state.totalPages = payload.totalPages;
    state.totalElmts = payload.totalElmts;
  },
  [types.LOAD_FAILED](state) {
    state.documentsList = [];
    state.totalPages = 1;
    state.totalElmts = 0;
  },
  [types.LOAD_FOLDERS_SUCCESS](state, folders) {
    state.allFolders = folders;
  },
  [types.LOAD_FOLDERS_FAILED](state) {
    state.allFolders = [];
  },
  [types.LOAD_DOCUMENTS_SENDERS_SUCCESS](state, documentsSenders) {
    state.documentsSenders = documentsSenders;
  },
  [types.LOAD_DOCUMENTS_SENDERS_FAILED](state) {
    state.documentsSenders = [];
  },
  [types.GET_DOCUMENT_DETAILS](state, documentDetails) {
    state.documentDetails = documentDetails;
  },
  [types.GET_SUBSCRIBED_FILE_TYPES](state, fileTypes) {
    state.subscribedFileTypes = fileTypes;
  },
  [types.LOAD_ONE](state, details) {
    state.documentDetails = details;
  },
  [types.LOAD_STATS_SUCCESS](state, stats) {
    state.stats = stats;
  },
  [types.LOAD_STATS_FAILED](state) {
    state.stats = {};
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/documents/mutations.js